import React from "react";
import { Box, Typography } from "@mui/material";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";

const FRIENDLY_ERROR_MESSAGE = "Oops! Something went wrong. Please try again later.";

const normalizeDisplayLine = (line) =>
  /networkerror|network error|failed to fetch/i.test(String(line || ""))
    ? FRIENDLY_ERROR_MESSAGE
    : line;

export default function ErrorMessage({ msg }) {
  const lines = String(msg.content ?? "")
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean);
  const displayLines = (lines.length ? lines : [FRIENDLY_ERROR_MESSAGE]).map(
    normalizeDisplayLine,
  );

  return (
    <Box
      sx={{
        p: { xs: 2, sm: 2.5 },
        minWidth: { xs: 260, sm: 360 },
        maxWidth: 520,
        borderRadius: 4,
        position: "relative",
        overflow: "hidden",
        background:
          "radial-gradient(circle at 14% 18%, rgba(219,165,41,0.28), transparent 28%), linear-gradient(135deg, rgba(255,255,255,0.16), rgba(255,255,255,0.06))",
        border: "1px solid rgba(219,165,41,0.2)",
        backdropFilter: "blur(22px) saturate(120%)",
        WebkitBackdropFilter: "blur(22px) saturate(120%)",
        boxShadow:
          "inset 0 1px 0 rgba(255,255,255,0.18), 0 18px 42px rgba(0,0,0,0.2)",
        "&::before": {
          content: '""',
          position: "absolute",
          left: 0,
          top: 12,
          bottom: 12,
          width: 3,
          borderRadius: "999px",
          background: "linear-gradient(180deg, #f3c94a, rgba(219,165,41,0.18))",
        },
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1 }}>
        <Box
          sx={{
            width: 42,
            height: 42,
            borderRadius: "50%",
            display: "grid",
            placeItems: "center",
            bgcolor: "rgba(219, 165, 41, 0.12)",
            border: "1px solid rgba(219, 165, 41, 0.32)",
            boxShadow: "0 0 22px rgba(219,165,41,0.14)",
            flexShrink: 0,
          }}
        >
          <ErrorOutlineRoundedIcon sx={{ color: "#f3c94a", fontSize: 22 }} />
        </Box>
        <Typography
          sx={{
            color: "rgba(243,201,74,0.9)",
            fontSize: 11,
            fontWeight: 800,
            letterSpacing: "0.16em",
            textTransform: "uppercase",
          }}
        >
          Signal interrupted
        </Typography>
      </Box>

      {displayLines.map((line, index) => (
        <Typography
          key={`${index}-${line.slice(0, 12)}`}
          sx={{
            color:
              index === 0 ? "#fff" : "rgba(255,255,255,0.72)",
            fontSize: index === 0 ? "0.92rem" : "0.8rem",
            fontWeight: index === 0 ? 650 : 400,
            lineHeight: 1.5,
            mt: index > 0 ? 0.75 : 0,
          }}
        >
          {line}
        </Typography>
      ))}
    </Box>
  );
}